/* eslint-disable no-template-curly-in-string */

export default [
  {
    message: '${name}! Glad to have you back.',
    min: 0,
    max: 23,
  },
  {
    message: 'Did something interesting happen to you today, ${name}?',
    min: 0,
    max: 23,
  },
  {
    message: 'Did something noteworthy just cross your mind, ${name}?',
    min: 0,
    max: 23,
  },
  {
    message: 'What did you just have to think about, ${name}?',
    min: 0,
    max: 23,
  },
  {
    message: 'Did you notice something beautiful yet today, ${name}?',
    min: 0,
    max: 23,
  },
  {
    message: 'Did something special happen today, ${name}?',
    min: 0,
    max: 23,
  },
  {
    message: 'It’s so late, ${name}. Why can’t you sleep?',
    min: 2,
    max: 4,
  },
  {
    message: 'Did you have a nightmare, ${name}? Everything is okay, it was just a dream.',
    min: 3,
    max: 4,
  },
  {
    message: 'Did you just get up or didn’t you go to bed yet, ${name}? Why?',
    min: 2,
    max: 5,
  },
  {
    message: 'What’s keeping you awake, ${name}?',
    min: 2,
    max: 4,
  },
  {
    message: 'You’re up early, ${name}. Anything exciting coming up?',
    min: 5,
    max: 7,
  },
  {
    message: 'Good morning ${name}! What are you planning on doing today?',
    min: 5,
    max: 11,
  },
  {
    message: 'Good morning ${name}, how are you doing today?',
    min: 5,
    max: 11,
  },
  {
    message: 'Good morning! Did you have any interesting dreams last night, ${name}?',
    min: 5,
    max: 11,
  },
  {
    message: 'Good day ${name}! What’s on your mind?',
    min: 12,
    max: 16,
  },
  {
    message: 'Hi, ${name}! How’s your day been so far?',
    min: 10,
    max: 22,
  },
  {
    message: 'Hi, ${name}! How’s your day going so far?',
    min: 10,
    max: 22,
  },
  {
    message: 'Good day ${name}! How are you feeling?',
    min: 12,
    max: 16,
  },
  {
    message: 'What’s your lunch going to be, ${name}?',
    min: 12,
    max: 14,
  },
  {
    message: 'Good afternoon, ${name}! Do you have anything to write down?',
    min: 14,
    max: 17,
  },
  {
    message: 'Good afternoon, ${name}! What crossed your mind just now?',
    min: 14,
    max: 17,
  },
  {
    message: 'Good evening, ${name}! What was your day like?',
    min: 18,
    max: 22,
  },
  {
    message: 'Good evening, ${name}. Did you have a good day?',
    min: 18,
    max: 22,
  },
  {
    message: 'What are some good things that happened to you today, ${name}?',
    min: 18,
    max: 22,
  },
  {
    message: 'What are you going to do tonight, ${name}?',
    min: 18,
    max: 22,
  },
  {
    message: 'Are you especially excited about something tonight, ${name}?',
    min: 18,
    max: 22,
  },
  {
    message: 'Good night, ${name}. What exiting experiences did you make today?',
    min: 23,
    max: 2,
  },
  {
    message: 'It’s getting late, ${name}. Is something going around your mind?',
    min: 23,
    max: 3,
  },
];
